import { ImageData } from './localized-domain-images';
import { PageItemWithCountries } from './page-item';
import { TrayWithLocalizedTitle, TrayWithLocalizedBackgroundImages, TrayWithLocalizedCOTVImages, TrayWithScheduling } from './tray-common';
import { StudiosTrayLayout } from './domain-layouts';
import { LocalizedData } from './localized-data';

export enum GenericCarouselTargetType {
  Page = 'Page',
  ContentGroup = 'ContentGroup',
}

export interface CategoryItem extends TrayWithLocalizedBackgroundImages, TrayWithLocalizedCOTVImages {
  title: LocalizedData<string>;
  id: string;
  targetType: GenericCarouselTargetType;
  marketingLabel: LocalizedData<string>;
  genres: string[];
  pageId?: string;
  feedId?: string;
}

interface GenericTray extends PageItemWithCountries, TrayWithScheduling {
  title: LocalizedData<string>;
  type: 'GenreTray' | 'StudiosTray';
  categories: CategoryItem[];
}

export interface GenreTray extends GenericTray {
  type: 'GenreTray';
}

export interface StudiosTray extends GenericTray {
  type: 'StudiosTray';
  layout: StudiosTrayLayout;
}

export interface GenericCarouselGenericItem extends TrayWithLocalizedTitle {
  id: string;
  targetType: GenericCarouselTargetType;
  pageId?: string;
  feedId?: string;
  imageWebEnglish: ImageData;
  imageWebArabic: ImageData;
  imageMobileEnglish: ImageData;
  imageMobileArabic: ImageData;
  imageTabletEnglish: ImageData;
  imageTabletArabic: ImageData;
  imageCoTvEnglish: ImageData;
  imageCoTvArabic: ImageData;
}

export enum GenericCarouselLayout {
  Branded = 'Branded',
  Genre = 'Genre',
  Kids = 'Kids',
}

export interface GenericCarousel extends PageItemWithCountries {
  titleEnglish: string;
  titleArabic: string;
  type: 'GenericCarousel';
  scheduledFrom: number;
  scheduledTo: number;
  layout: GenericCarouselLayout;
  genericItems: GenericCarouselGenericItem[];
}

export interface CategoryItem extends TrayWithLocalizedBackgroundImages, TrayWithLocalizedCOTVImages {
  title: LocalizedData<string>;
  id: string;
  targetType: GenericCarouselTargetType;
  marketingLabel: LocalizedData<string>;
  genres: string[];
  pageId?: string;
  feedId?: string;
}

interface GenericTray extends PageItemWithCountries, TrayWithScheduling {
  title: LocalizedData<string>;
  type: 'GenreTray' | 'StudiosTray';
  categories: CategoryItem[];
}

export interface GenreTray extends GenericTray {
  type: 'GenreTray';
}

export interface StudiosTray extends GenericTray {
  type: 'StudiosTray';
  layout: StudiosTrayLayout;
}
